import { InlineExpander, Text, isMobileStyleMixin as isMobile } from '@amzn/storm-ui'
import styled, { css } from 'styled-components'

export const PartnerComparisonTableInlineExpander = styled(InlineExpander)`
  align-items: center;
  :hover {
    text-decoration: none;
  }
  font-size: ${({ theme }) => theme.spacing.medium};
  margin-top: ${({ theme }) => theme.spacing.xlarge};
  padding-inline-start: 0;
  width: 100%;
  ${isMobile(css`
    width: 90%;
  `)}
`

export const PartnerComparisonStyledTable = styled.table`
  width: 100%;
  border-bottom: 1px solid ${({ theme }) => theme.palette.gray['150']};
  color: ${({ theme }) => theme.typography.color.base};
  border-spacing: 0px;
`

export const PartnerComparisonTableHeadRow = styled.tr`
  display: flex;
  align-items: center;
  height: ${({ theme }) => theme.spacing.xxlarge};
  background-color: ${({ theme }) => theme.palette.gray['25']};
  border-top: 1px solid ${({ theme }) => theme.palette.gray['150']};
`

export const PartnerComparisonTableBody = styled.tbody`
  width: 100%;
`

export const PartnerComparisonTableHeadTD = styled.td`
  margin-inline-start: ${({ theme }) => theme.spacing.small};
`

export const PartnerComparisonTableBodyRow = styled.tr`
  display: flex;
  border-top: 1px solid ${({ theme }) => theme.palette.gray['150']};
  width: 100%;
  background-color: white;
`

export const PartnerComparisonTableBodyTD = styled.td`
  display: flex;
  align-items: center;
  height: inherit;
  width: 25%;
  border-inline-end: 1px solid ${({ theme }) => theme.palette.gray['150']};
  padding: ${({ theme }) => theme.spacing.small};
  &:not(:first-child) {
    justify-content: center;
  }
  :last-child {
    border-inline-end: none;
  }
  ${isMobile(css`
    :first-child {
      width: 90%;
    }
    :nth-child(2) {
      width: 10%;
    }
  `)}
`

export const PartnerComparisonAdditionalInfoRow = styled.tr`
  border-top: 1px solid ${({ theme }) => theme.palette.gray['150']};
  display: flex;
  width: 100%;
  ${isMobile(css`
    flex-direction: column;
  `)}
`
export const PartnerComparisonAdditionalInfoTD = styled.td`
  word-wrap: break-word;
  display: flex;
  justify-content: flex-start;
  height: inherit;
  width: 25%;
  border-inline-end: 1px solid ${({ theme }) => theme.palette.gray['150']};
  padding: ${({ theme }) => theme.spacing.small};
  :last-child {
    border-inline-end: none;
  }
  ${isMobile(css`
    width: 100%;
    border-inline-end: none;
    :first-child {
      background-color: ${({ theme }) => theme.palette.gray['25']};
      border-bottom: 1px solid ${({ theme }) => theme.palette.gray['150']};
    }
  `)}
`
export const PartnerComparisonStyledText = styled(Text)`
  display: flex;
  padding: ${({ theme }) => theme.spacing.micro};
  ${isMobile(css`
    padding: ${({ theme }) => theme.spacing.micro} 0 ${({ theme }) => theme.spacing.micro} 0;
  `)}
`
